import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankTransferAdministrativeLogService {

  private url = environment.api;
    constructor(
      private http: HttpClient,
    ) { }

  getDepositRequests(startDate: string) {
		return this.http.get(this.url + `api/erp/bank/admins/deposits/${startDate}`);
	}

  respondDepositRequest(data: any, id: any) {
    return this.http.put(this.url + `api/erp/bank/admins/deposit/${id}`, data);
  }

  getDepositRequestsApp(millisDate: number,warehouseId: number) {
    return this.http.get(this.url +`api/erp/bank/admins/transfers/warehouse/${warehouseId}/${millisDate}`);
  }

  saveTransferCashBank(data: any) {
    return this.http.post(this.url + 'api/erp/bank/localtransfer/app-admins',data);
  }

}
